import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-jjblue/60">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
